import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Row } from 'antd';
import { FormInput } from '@monorepo/react-components';
import { NyseFormProps } from '../nyse-modal-content';

const NyseStepEight: FunctionComponent<NyseFormProps> = ({ form }) => {
  const { t } = useTranslation(['contractModal', 'common']);

  return (
    <div className={'contracts-steps-body'}>
      <div>
        <p>{t('contractModal:nyse_modal.permitted_use')}</p>

        <Row justify={'space-evenly'} align={'middle'}>
          <FormInput
            text={t('common:first_name')}
            form={form}
            controllerProps={{ name: 'firstName' }}
          />
          <FormInput
            text={t('common:last_name')}
            form={form}
            controllerProps={{ name: 'lastName' }}
          />
        </Row>
        <Row justify={'space-evenly'} align={'middle'}>
          <FormInput
            text={t('common:address')}
            form={form}
            controllerProps={{ name: 'address' }}
          />
          <FormInput
            text={t('contractModal:nyse_modal.occupations')}
            form={form}
            controllerProps={{ name: 'occupations' }}
          />
        </Row>
        <Row justify={'space-evenly'} align={'middle'}>
          <FormInput
            text={t('common:company_name')}
            form={form}
            controllerProps={{ name: 'companyName' }}
          />
          <FormInput
            text={t('contractModal:nyse_modal.employer')}
            form={form}
            controllerProps={{ name: 'employer' }}
          />
        </Row>
        <Row justify={'space-evenly'} align={'middle'}>
          <FormInput
            text={t('contractModal:nyse_modal.employer_address')}
            form={form}
            controllerProps={{ name: 'employerAddress' }}
          />
          <FormInput
            text={t('contractModal:nyse_modal.title')}
            form={form}
            controllerProps={{ name: 'title' }}
          />
        </Row>
        <Row justify={'space-evenly'} align={'middle'}>
          <FormInput
            text={t('contractModal:nyse_modal.employment_functions')}
            form={form}
            controllerProps={{ name: 'employmentFunctions' }}
          />
        </Row>

        <p>{t('contractModal:nyse_modal.subscriber_change_notice')}</p>
      </div>
    </div>
  );
};

export default NyseStepEight;
